import { useQuery } from '@tanstack/react-query'
import { gqlRequest, type RequestSession } from './api/client'
import { ConfigurationQuery } from './api/operations'
import { packingLabels, readConfiguration, screenSettings } from './configuration'

export function useConfiguration(session: RequestSession, restaurantId: string, displayId: string) {
  const query = useQuery({
    queryKey: ['configuration', session.mode, restaurantId, displayId],
    enabled: Boolean(session.token && restaurantId),
    queryFn: async () => {
      const data = await gqlRequest(session, ConfigurationQuery, { restaurantId, kitchenDisplayId: displayId })
      const config = readConfiguration(data.restaurant ?? undefined)
      config.labels = packingLabels(data.restaurant?.labels, data.restaurant?.kitchenDisplay?.labels)
      const settings = screenSettings(config, data.restaurant?.kitchenDisplay?.screen)
      return { ...data, config, settings }
    },
    refetchInterval: 30_000,
  })
  const config = query.data?.config ?? readConfiguration()
  return { ...query, config, settings: query.data?.settings ?? config.screenDefaults }
}
